module.exports = __webpack_public_path__ + "static/media/07.6dc29950.jpg";